import styled, { css } from 'styled-components';

export const Wrapper = styled.div`
  max-width: 940px;
  min-height: 460px;
  text-align: start;
  width: 100%;
`;

export const Title = styled.h1`
  ${({ theme }) => css`
    color: ${theme.v2.colors.brand.primaryExtraDark};
    font-size: ${theme.v2.font.sizes.md};
    font-weight: ${theme.v2.font.weights.medium};
    margin: 8px 0;
  `};
`;

export const Description = styled.span`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowDark};
    font-size: ${theme.v2.font.sizes.xs};
  `};
`;

export const TooltipWrapper = styled.div`
  align-items: flex-end;
  display: inline-flex;
  justify-content: end;
  position: relative;
  top: 3px;
  width: 20px;
`;

export const NavWrapper = styled.div`
  display: inline-block;
  margin: 32px 0;
  width: 100%;
`;

export const NavbarContainer = styled.div`
  ${({ theme }) => css`
    align-items: end;
    background: ${theme.v2.colors.neutral.highLight};
    border-radius: 8px 8px 0px 0px;
    display: flex;
    padding-top: 8px;
    width: 100%;
  `};
`;

export const NavbarImage = styled.img`
  height: 32px;
  user-select: none;
  -webkit-user-drag: none;
`;

export const DomainInputWrapper = styled.div`
  ${({ theme }) => css`
    background: ${theme.v2.colors.white.primary};
    border-radius: 0px 0px 8px 8px;
    min-height: 78px;
    padding: 18px 24px;
  `};
`;

export const RadixUnavailableMessage = styled.div`
  margin: 8px 0 0;
`;

export const DomainFieldsContainer = styled.div`
  ${({ theme }) => css`
    display: flex;
    gap: 8px;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      flex-direction: column;
    }
  `};
`;

export const ErrorText = styled.p`
  ${({ theme }) => css`
    color: ${theme.v2.colors.feedback.problemDark};
    font-size: ${theme.v2.font.sizes.xs};
    margin: 8px 0 0;
  `};
`;

export const InputInstruction = styled.p`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowMedium};
    font-size: ${theme.v2.font.sizes.xxs};
    margin: 32px 0 0;

    strong {
      font-weight: ${theme.font.weights.medium};
    }
  `};
`;

export const TextFieldContainer = styled.div`
  ${({ theme }) => css`
    width: 100%;

    > div > div {
      padding-left: 67px;
      position: relative;
      outline: none;

      &:before {
        color: ${theme.v2.colors.neutral.lowMedium};
        content:'www.';
        font-family: ${theme.v2.font.family.primary};
        font-size: ${theme.v2.font.sizes.xxs};
        font-weight: ${theme.v2.font.weights.regular};
        left: 16px;
        line-height: ${theme.v2.font.lineHeight.text};
        position: absolute;
        top: 18px;
      }
    }

  `};
`;

export const SelectFieldContainer = styled.div`
  ${({ theme }) => css`
    min-width: 280px;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      min-width: auto;
    }
  `};
`;

export const TagLabel = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const OtherOptionsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 24px;
`;

export const OtherOptionsTitle = styled.div`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowDark};
    font-size: ${theme.v2.font.sizes.xxs};
    font-weight: ${theme.v2.font.weights.medium};
    margin: 0;
  `};
`;

export const OtherOptionsList = styled.ul`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  list-style-type: none;
  padding: 0;
`;

export const OtherOptionItem = styled.li`
  button {
    border: 1px solid #CDD8DF;
    color: #4A4A4A;
    padding: 8px 16px;
  }
`;
